import React, { useState, useEffect } from 'react';
import Select from 'react-select';
import { ScreenHeader } from "../UI/Elements"
import { AdminIcon, AdminIcons } from "../Shared/AdminIcon"
import { CustomColumnContainer } from '../Shared/Formelements';
import { Data } from '../../Handlers/Data';
import { MessageBoxes } from '../../Handlers/MessageBoxes';
import { simulateDelay } from '../../Handlers/Helpers';
import { FetchHandler } from '../../Handlers/FetchHandler';
import { Overlay } from '../UI/Overlay';
import { useUsers } from '../../hooks/useUsers';
import { JsonHubProtocol } from '@microsoft/signalr';
import { JwtImage } from '../UI/ImageElements';
import { useGamificationScreen } from './GamificationScreen';

export const GamificationImagesScreen = () => {

    const ui = useGamificationScreen();
    const ops = useGamificationImagesScreen();
    const users = useUsers();


    useEffect(() => {
        ui.load();
        ops.load();
    }, []);

    useEffect(() => {
        users.ensureUserInfo(ops.data?.map(m => m.sys_created_by_user_id));
    }, [ops.data]);

    return (
        <div className="gamification-screen">
            <ScreenHeader text="Gamification bilder" icon={AdminIcons.images} />
            <div className='image-grid'>
                {ops.data?.map(img => (
                    <div key={img.id} className='grid-image'>
                        <JwtImage imageId={img.id} format="thumb" openOnClick={true} />
                        <div className='bold'>
                            {users.getUsersName(img?.sys_created_by_user_id)}:
                        </div>
                        <div>
                            {ui.rawData?.[img?.refid]?.name_sv}
                        </div>
                    </div>
                ))}

            </div>
        </div>
    )
}

const useGamificationImagesScreen = () => {


    const [data, setData] = useState<GImage[]>([])

    const load = async () => {
        let d: GImage[] = await FetchHandler.getJson("/api/gamification/images");
        d.sort((a, b) => {
            if (a?.sys_datecreated_utc_epoch > b?.sys_datecreated_utc_epoch) { return -1; }
            else if (a?.sys_datecreated_utc_epoch < b?.sys_datecreated_utc_epoch) { return 1; }
            else { return 0; }
        });
        setData(d);
    }
    return {
        load,
        data,

    }
}


type GImage = {
    id: string
    label: string
    partition: string
    filename: string
    length: number
    contenttype: string
    dateaddedutc: string
    name: string
    refid: string
    reftype: string
    imageid: string
    sys_datecreated_utc_epoch: number
    sys_created_by_user_id: string
}
